import gql from 'graphql-tag'

export const CREATE_STOCK_HISTORY = gql`
mutation ($stockHistory:[StockHistory_insert_input!]!) {
  insert_StockHistory(objects: $stockHistory){
    returning{
      id
    }
  }  
}`

export const ADD_STOCK_ORDER = gql`
mutation addStockOrder($order:[StockOrder_insert_input!]!, $orderItems:[StockHistory_insert_input!]!) {
  insert_StockOrder(objects: $order){
   affected_rows
  }
  insert_StockHistory(objects: $orderItems){
   affected_rows
  }
}`
